export default __webpack_public_path__ + "static/1-4f2c822377b13c880aa8ceacb968e339.png";